var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",staticStyle:{"background-color":"#13255d !important"}},[_c('ServicePlaceAddStepper',{on:{"Saved":_vm.SavedEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }